import type React from 'react'

/**
 * Visual variant for SkuDetailCta. Use 'detail' on SKU detail/urgent-care pages;
 * use theme variants (primary, primary-white, etc.) in Refresh category pages.
 */
export type SkuCtaVariant =
    | 'detail'
    | 'primary'
    | 'primary-white'
    | 'primary-blue'
    | 'outline'
    | 'outline-dark'

export interface SkuCtaStyleConfig {
    variant: 'filled' | 'outline'
    bg?: string
    c?: string
    rootStyles?: React.CSSProperties
}

export const skuCtaStyles: Record<SkuCtaVariant, SkuCtaStyleConfig> = {
    detail: {
        variant: 'filled',
        rootStyles: { height: 48, maxWidth: 450 },
    },
    primary: {
        variant: 'filled',
        bg: 'blue.6',
        c: 'white',
    },
    'primary-white': {
        variant: 'filled',
        bg: 'white',
        c: 'gray.9',
    },
    'primary-blue': {
        variant: 'filled',
        bg: 'blue.2',
        c: 'gray.9',
    },
    outline: {
        variant: 'outline',
        bg: 'transparent',
        c: 'gray.9',
        rootStyles: { borderColor: 'var(--gm-fg-gray, #878685)' },
    },
    'outline-dark': {
        variant: 'outline',
        c: 'white',
        rootStyles: {
            background: 'linear-gradient(169deg, #0C0E1C 2.03%, #0F1227 40.08%, #1B1D48 106.16%)',
        },
    },
}

export function getSkuCtaStyles(variant: SkuCtaVariant): SkuCtaStyleConfig {
    return skuCtaStyles[variant]
}
